import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// ---- Sentry (frontend) ---------------------------------------------------
// Wire only when a DSN is configured — no-ops in dev / preview without one.
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
if (SENTRY_DSN) {
  // Lazy-load so the bundle isn't bloated when Sentry isn't in use.
  import("@sentry/react").then((Sentry) => {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: process.env.REACT_APP_SENTRY_ENV || "production",
      tracesSampleRate: 0.1,
      replaysSessionSampleRate: 0.0,
      replaysOnErrorSampleRate: 1.0,
      integrations: [Sentry.browserTracingIntegration()],
      // Never send user PII unless we identify them explicitly
      sendDefaultPii: false,
    });
  }).catch(() => { /* Sentry package not installed; ignore silently */ });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
